export const USER_PERMISSION = {
  USER: 'USER',
  ADMIN: 'ADMIN',
};
